export const TABLE_HEIGHT = 400
